// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"587c951f","375":"c87481b7","789":"9cadeee6","821":"5ded8f7c","943":"e4b5cabb","998":"c35aab62"}[chunkId] + ".chunk.js";
};